"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _facebookLoginRenderProps = _interopRequireDefault(require("react-facebook-login/dist/facebook-login-render-props"));

var _reactGoogleLogin = _interopRequireDefault(require("react-google-login"));

var _EmailLogin = _interopRequireDefault(require("./EmailLogin"));

var _OTPLogin = _interopRequireDefault(require("./OTPLogin"));

var _baseModule = _interopRequireDefault(require("../styles/base.module.css"));

var _loginModule = _interopRequireDefault(require("../styles/login.module.css"));

var _constant = require("./constant");

var _googleButton = _interopRequireDefault(require("./google-button"));

var _facebookButton = _interopRequireDefault(require("./facebook-button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Login =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Login, _React$Component);

  function Login(props) {
    var _this;

    _classCallCheck(this, Login);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Login).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "switchLoginMode", function (mode) {
      _this.setState({
        loginMode: mode
      });
    });

    _defineProperty(_assertThisInitialized(_this), "googleRequested", function (bool) {
      _this.setState({
        googleRequested: bool
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fbRes", function (res) {
      _this.socialResponse(res, 'facebook');
    });

    _defineProperty(_assertThisInitialized(_this), "googleRes", function (res) {
      _this.googleRequested(false);

      _this.socialResponse(res, 'google');
    });

    _defineProperty(_assertThisInitialized(_this), "socialResponse", function (res, type) {
      var postData;

      if (type === 'facebook' && res.email) {
        postData = {
          name: res.name,
          first_name: res.first_name,
          last_name: res.last_name,
          gender: res.gender,
          provider: type,
          email: res.email,
          provider_id: res.id,
          token: res.accessToken,
          provider_pic: res.picture.data.url
        };
      }

      if (type === 'google' && res.w3 && res.w3.U3) {
        postData = {
          name: res.w3.ig,
          first_name: res.w3.ofa,
          last_name: res.w3.wea,
          provider: type,
          email: res.w3.U3,
          provider_id: res.El,
          token: res.Zi.access_token,
          provider_pic: res.w3.Paa,
          gender: ''
        };
      }

      var jsonEncoded = JSON.stringify(postData);
      var formData = new FormData();
      formData.append('userData', jsonEncoded);

      _this.signUp(formData);
    });

    _defineProperty(_assertThisInitialized(_this), "signUp", function (formData) {
      var onSuccess = _this.props.onSuccess;
      fetch("".concat(_constant.API_ROOT, "signup.php"), {
        credentials: 'same-origin',
        method: 'POST',
        body: formData
      }).then(_constant.checkStatus).then(_constant.parseJSON).then(function (data) {
        if (data.status) {
          onSuccess(data.uid);
        }
      }).catch(function (err) {
        return console.log(err);
      });
    });

    _this.state = {
      loginMode: _constant.EMAIL_LOGIN_MODE,
      googleRequested: false
    };
    return _this;
  }

  _createClass(Login, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          heading = _this$props.heading,
          onSuccess = _this$props.onSuccess;
      var _this$state = this.state,
          loginMode = _this$state.loginMode,
          googleRequested = _this$state.googleRequested;
      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: _baseModule.default.heading2
      }, heading), _react.default.createElement("div", {
        className: _baseModule.default.container
      }, loginMode === _constant.OTP_LOGIN_MODE ? _react.default.createElement(_OTPLogin.default, {
        onSuccess: onSuccess,
        switchMode: this.switchLoginMode
      }) : _react.default.createElement(_EmailLogin.default, {
        onSuccess: onSuccess,
        switchMode: this.switchLoginMode
      }), _react.default.createElement("div", {
        className: _loginModule.default.orContainer
      }, _react.default.createElement("span", null), _react.default.createElement("span", null, "or"), _react.default.createElement("span", null)), _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement(_facebookLoginRenderProps.default, {
        appId: "309421312498803",
        autoLoad: false,
        fields: "first_name,last_name,email,picture.type(large),gender",
        callback: this.fbRes,
        disableMobileRedirect: true,
        cookie: true,
        isDisabled: false,
        render: function render(renderProps) {
          return _react.default.createElement(_facebookButton.default, {
            onClick: renderProps.onClick,
            isProcessing: renderProps.isProcessing,
            type: "login"
          });
        }
      }), _react.default.createElement(_reactGoogleLogin.default, {
        clientId: "122886612551-o7p73gclfo8cqsup78mskkcdtkjmkaqi.apps.googleusercontent.com",
        onSuccess: this.googleRes,
        onFailure: this.googleRes,
        onRequest: function onRequest() {
          return _this2.googleRequested(true);
        },
        render: function render(renderProps) {
          return _react.default.createElement(_googleButton.default, {
            isProcessing: googleRequested,
            type: "login",
            onClick: renderProps.onClick,
            disabled: renderProps.disabled
          });
        }
      })), _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: _baseModule.default.divider
      }), _react.default.createElement("p", {
        className: "".concat(_baseModule.default.small, " ").concat(_baseModule.default.light)
      }, "Don\u2019t have an account?", _react.default.createElement("span", {
        style: {
          marginLeft: '0.25rem'
        },
        className: "".concat(_baseModule.default.small, " ").concat(_baseModule.default.link, " ").concat(_baseModule.default.bold),
        onClick: this.props.signUp
      }, "Sign up")))));
    }
  }]);

  return Login;
}(_react.default.Component);

Login.defaultProps = {
  heading: 'Log in to continue'
};
Login.propTypes = {
  heading: _propTypes.default.string
};
var _default = Login;
exports.default = _default;